import React from 'react';
import Name from '../../Name/Name';
import Experince from '../../Experince/Experince';
import Education from '../../Education/Education';
import Courses from '../../Courses/Courses';

import './Right.css';

const Right = () => {
  return (
    <div className='Right'>
      <Name />
      <Experince />
      <Education />
      <Courses />
    </div>
  )
}

export default Right